import React from "react";
import EducationClassroom from "./EducationClassroom";

export default function EduScience() {
  return (
    <EducationClassroom
      subject="science"
      title="Science Classroom"
      description="Learn biology, chemistry, physics, Earth science, space science, and scientific reasoning with Ava."
      placeholder="Ask a science question, such as: How does photosynthesis work?"
    />
  );
}
